// This file is autogenerated. Any changes will be overwritten.

export const set = 'budicon';

export const name = 'folder-close';

export const Component = () => (
  <path d='m9.674 11.004 2.586 2.586 2.586-2.586a.434.434 0 0 1 .335-.144c.335 0 .527.144.527.48 0 .047-.048.143-.144.334L12.93 14.26l2.634 2.635a.434.434 0 0 1 .144.335c0 .335-.192.479-.527.479a.434.434 0 0 1-.335-.144l-2.586-2.586-2.586 2.586a.434.434 0 0 1-.335.144c-.335 0-.527-.144-.527-.48 0-.143.048-.238.144-.334l2.635-2.635-2.635-2.586a.434.434 0 0 1-.143-.335c0-.335.143-.479.478-.479a.54.54 0 0 1 .383.144Zm14.847-5.077v16.715c0 .24-.096.48-.287.67a.946.946 0 0 1-.67.288H.957a.946.946 0 0 1-.67-.288.946.946 0 0 1-.288-.67V3.006c0-.239.096-.479.287-.718A.946.946 0 0 1 .958 2H9.1c.527 0 .814.24.91.67l.767 2.3h12.787c.24 0 .48.096.67.287a.946.946 0 0 1 .288.67Zm-.958 16.715V5.927H10.105L9.1 3.007H.959v19.635h22.605Z' />
);

export const viewBox = '0 0 25 25';
